import { FieldInputProps, FormikProps } from "formik";

type handleGiftCardTypeSelectionProps = {
  item: string;
  field: FieldInputProps<any>;
  form: FormikProps<any>;
}

export const handleGiftCardTypeSelection = (props: handleGiftCardTypeSelectionProps) => {
    const { item, field, form } = props;

    const valuesArray = Object.keys(form.values);
    valuesArray.forEach((field: any) => {
        if (form.values[field]) {
        form.setFieldTouched(field, true);
        form.setFieldError(field, "");
        } else {
        form.setFieldTouched(field, false);
        }
    });
    form.setFieldValue(field.name, item);
}
